import api, { formDataInstance } from "./baseRequest";

export const homeBannerService = {
  getHomeBanner: () => {
    return api.get("/admin/home-banner");
  },

  updateHomeBanner: (id, bannerData) => {
    const formData = new FormData();
    formData.append("title", bannerData.title);
    formData.append("description", bannerData.description);
    formData.append("buttonName", bannerData.buttonName);
    formData.append("buttonLink", bannerData.buttonLink);
    if (bannerData.image) {
      formData.append("image", bannerData.image);
    }
    if (bannerData.mobile_image) {
      formData.append("mobile_image", bannerData.mobile_image);
    }

    return formDataInstance.put(`/admin/home-banner/${id}`, formData);
  },
};
